<template>
    <div>
        <Form :data="data" />
        <List :data="data" />
    </div>
</template>

<script>
// Components
import Form from './Form'
import List from './List'

export default {
    components: { Form, List },
    props: {
        data: { type: Object, required: true }
    },
    methods: {
        async validate() {

            return true
        },
    },
}
</script>